<template>
 <Breadcrumb page-title="Manage KB Article" page-section="Manage Work Queue"> </Breadcrumb>
  <section class="content">
    <div class="row"> 
        <div class="col-12">
            <div class="btn-group pull-right mbottom-15" id="realtime" data-toggle="btn-toggle">
                <a class="btn btn-default" data-toggle="on" href="/pages/manage-kb-article-listview.html">List View</a>
                <a class="btn btn-primary active" data-toggle="off" href="/pages/manage-kb-article.html">Tree View</a>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-4" v-bind:class = "menuCollapse ?'treeview-expand':'treeview-collapse'">
          <div class="box box-primary">
            <div class="box-header with-border heading-with-toggle" >
                <i class="fa fa-list-ul"></i>
                <h3 class="box-title text-right">Topic List</h3>
                <span aria-hidden="true" class="pull-right  mleft-15 menu-collapse" v-on:click="menuCollapse = !menuCollapse;"><i class="fa fa-reorder treeview-collapse-icon"></i></span>
                <span v-on:click="treeView()" aria-hidden="true" class="menu-collapse glyphicon  pull-right glyphicon-chevron-right mleft-15 treeview-expand-icon" ng-class="{'glyphicon-chevron-right__expanded': !isCollapsedTreeView}" ng-init="isCollapsedTreeView = false;"></span>
            </div>
            <div class="box-body search-criteria topic-list-container">
            
                <div class="row">
                    <div class="col-12 message-head">
                        <label class="pull-left select-all-topic">
                        <input type="checkbox" class="form-check-input mright-5">Select All</label> 
                        
                        <div class="pull-right count-block">
                            #
                        </div>
                    </div> 
                </div>
                <div class="treeview topic-list  active-chat" v-if="!showmytopic">
                    <div class="treeview-segment-name">   
                        E-shop
                    </div>		
                  <ul id="tree1" class="topictree tree">
											<li class="branch"><i class="indicator fa fa-minus-circle mright-5"></i>
												
												<input type="checkbox" class="form-check-input mright-5">
												<div class="treeviewitem">
													<div class="treeviewrow">
														<div class="div1"> All Topic</div> 
													</div>	
												</div>
												<div class="count-columns">
													<div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div>
												</div>
												
												<ul>
													<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1 text-red">  _Feedback</div> <div class="div2">&nbsp;</div></div></div> <div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
													<li><input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1 text-red">_Newsletter Subscription</div></div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
													<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1 text-red">_Spam</div><div class="div2">&nbsp;</div> </div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
													<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"> <div class="treeviewrow"><div class="div1 text-red">_Undeliverable</div> </div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
													<li class="branch"><i class="indicator fa fa-minus-circle mright-5"></i> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Account Questions</div></div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div>
														<ul>
															<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Orders </div> </div> </div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
															<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Refunds </div></div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
															<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Returns </div> </div> </div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
														</ul>
													</li>
													<li class="branch"><i class="indicator fa fa-minus-circle mright-5"></i> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Products</div><div class="div2">&nbsp;</div> </div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div>
														<ul>
															<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Audio-Video</div></div> </div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
															<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Cameras </div> </div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
															<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Cell Phones</div></div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
															<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Computers</div> </div> </div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
															<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Televisions</div> </div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
														</ul>
													</li>
													<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Shipping</div></div></div> <div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
													<li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Technical Support</div></div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
												
												</ul>
											</li>
										</ul>
                </div>

                 <div class="treeview topic-list  active-chat" v-if="showmytopic">
                    <div class="treeview-segment-name">   
                       Financial Services
                    </div>		
                  <ul id="tree1" class="topictree tree">
                    <li class="branch"><i class="indicator fa fa-minus-circle mright-5"></i>
                        
                        <input type="checkbox" class="form-check-input mright-5">
                        <div class="treeviewitem">
                            <div class="treeviewrow">
                                <div class="div1"> All Topic</div> 
                            </div>	
                        </div>
                        <div class="count-columns">
                            <div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div>
                        </div>
                        
                        <ul>
                            <li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1 text-red">  _Feedback</div> <div class="div2">&nbsp;</div></div></div> <div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
                            <li><input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1 text-red">_Newsletter Subscription</div></div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
                            <li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1 text-red">_Spam</div><div class="div2">&nbsp;</div> </div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
                            <li> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"> <div class="treeviewrow"><div class="div1 text-red">_Undeliverable</div> </div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div></li>
                            <li class="branch"><i class="indicator fa fa-minus-circle mright-5"></i> <input type="checkbox" class="form-check-input mright-5"><div class="treeviewitem"><div class="treeviewrow"><div class="div1">Account Questions</div></div></div><div class="count-columns"><div class="pull-right count-block text-aqua" v-tooltip="{text: 'Alek Packard',theme: {placement: 'bottom', }}">1</div></div>
                               
                            </li>
                          
                        </ul>
                    </li>
                </ul>
                </div>
            </div>
          </div>
        </div>
        <div class="p-l-0"  v-bind:class= "menuCollapse ?'col-8':'col-11'">
           
           <div class="row">
           
            <div class="col-12">
                <div class="box box-info">
                    <div class="box-header with-border">
                        <i class="fa fa-edit"></i>
                        <h3 class="box-title head-title-padding">New Article</h3>
                    </div>
                    <div class="box-body">
                      <div class="bg-box box-bg-color">
                        <div class="row">
                            <div class="pull-right text-end mbottom-15">
                                <button type="submit" class="btn btn-primary">Create</button>

                                <!--this will be button while development <button class="btn btn-link" type="button">Cancel </button>-->
                                <a class="btn btn-link" href="/pages/manage-kb-article.html">Cancel </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 form-horizontal">
                                <div class="form-group">
                                    <label class="col-2 control-label text-left">Subject</label>
                                    <div class="col-6">                              
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-2 control-label text-left">Choose Topic</label>
                                    <div class="col-6">                              
                                        <select class="form-control">
                                            <option value="All Topic">All Topic</option>
                                        </select>    
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-2 control-label text-left">Access Level</label>
                                    <div class="col-6">                              
                                        <select class="form-control">
                                            <option value="Public">Public</option>
                                        </select>    
                                    </div>
                                </div>
                            </div>
                        </div>

                        <NewKbArticle></NewKbArticle>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>			
    </div>
  </section>
</template>
<style src="@vueform/toggle/themes/default.css"></style>
<script>
// @ is an alias to /src
import Breadcrumb from '../components/Breadcrumb.vue';
import ChatButtons from '../components/ChatButtons.vue';
import MassUpdateBody from '../components/MassUpdateBody.vue';
import ManageKbArticleTableList from '../components/ManageKbArticleTableList.vue';
import NewKbArticle from '../components/NewKbArticle.vue';
import Toggle from '@vueform/toggle'
export default {
  name: 'Manage KB Articles',
  data() {
      return{
          showmore : false,
          segment1 : true,
          menuCollapse : true,
          showmytopic : false
      }
  },
  components: {
    Breadcrumb,
    ChatButtons,
    MassUpdateBody,
    ManageKbArticleTableList,
    Toggle,
    NewKbArticle
  },
  ready () {
    $(document).ready(function ($) {
    })
  },
   methods: {
    toggleSegmentCollapsedState(i) {
      this['segment'+i] = !this['segment'+i] 
    }
  }
}
</script>
